import { useContext, useEffect, useState } from "react";
import Perfil from "../../page/perfil/Perfil"
import { authContext } from "../../../../context/auth/AuthContext";
import apiPrivateAntesala from "../../../config/ConfigPrivate";
import RestPrivateAntesala from "../../../helpers/RestPrivateApi";

const PerfilController = () => {
    const { user } = useContext(authContext);
    const { data } = user;
    const [provincias, setProvincias] = useState(null);
    const [loading, setLoading] = useState(false);
    const [form, setForm] = useState({
        nombre: '',
        apellido: '',
        email: '',
        telefono: '',
        provincia: '',
        localidad: '',
        direccion: '',
        password: '',
        current_password: '',
        razon_social: '',
        website: '',
        url_facebook: '',
        url_instagram: '',
        descripcion: ''
    });

    const [galleryImages, setGalleryImages] = useState({
        imagen_desc_1: null,
        imagen_desc_2: null,
        imagen_desc_3: null,
        imagen_int_1: null,
        imagen_int_2: null,
        imagen_int_3: null,
    });

    const [billingForm, setBillingForm] = useState({
        dato_fiscal: '',
        cbu: '',
        entidad: '',
        email: '',
        porcentaje: ''
    });

    const [billingFiles, setBillingFiles] = useState({
        comprobante_afip: null,
        comprobante_cbu: null,
        comprobante_entidad: null
    });

    const [filePreview, setFilePreview] = useState({
        comprobante_afip: null,
        comprobante_cbu: null,
        comprobante_entidad: null,
    });

    const [billingLoading, setBillingLoading] = useState(false);

    useEffect(() => {
        if (data && data.datos) {
            const rol = data.roles[0].nombre;
            let initialForm = {};

            if (rol === 'adm') {
                initialForm = {
                    nombre: data.nombre || '',
                    apellido: data.apellido || '',
                    email: data.email || '',
                    telefono: data.telefono || '',
                    provincia: data.provincia || '',
                    localidad: data.localidad || '',
                    direccion: data.direccion || '',
                    password: '',
                    current_password: '',
                    razon_social: data.nombre || '',
                    website: data.datos?.website || '',
                    url_facebook: data.datos?.url_facebook || '',
                    url_instagram: data.datos?.url_instagram || '',
                    descripcion: ''
                };
            } else if (rol === 'sala') {
                initialForm = {
                    nombre: data.datos.nombre || '',
                    apellido: '',
                    email: data.datos.email || '',
                    telefono: data.datos.telefono || '',
                    provincia: data.datos.provincia || '',
                    localidad: data.datos.localidad || '',
                    direccion: data.datos.direccion || '',
                    password: '',
                    current_password: '',
                    razon_social: data.datos.razon_social || '',
                    website: data.datos.website || '',
                    url_facebook: data.datos?.url_facebook || '',
                    url_instagram: data.datos?.url_instagram || '',
                    descripcion: data.datos.descripcion || ''
                };
            } else if (rol === 'prd') {
                initialForm = {
                    nombre: data.datos.nombre || '',
                    apellido: '',
                    email: data.datos.prd_email || '',
                    telefono: data.datos.telefono || '',
                    provincia: data.datos.provincia || '',
                    localidad: data.datos.localidad || '',
                    direccion: data.datos.direccion || '',
                    password: '',
                    current_password: '',
                    razon_social: data.datos.nombre || '',
                    website: data.datos.website || '',
                    url_facebook: data.datos?.url_facebook || '',
                    url_instagram: data.datos?.url_instagram || '',
                    descripcion: data.datos.descripcion || ''
                };
            }

            setForm(initialForm);

            // Initialize gallery images for sala role
            if (rol === 'sala' && data.datos?.imagen_desc_1) {
                const existingImages = {
                    imagen_desc_1: data.datos.imagen_desc_1,
                    imagen_desc_2: data.datos.imagen_desc_2,
                    imagen_desc_3: data.datos.imagen_desc_3,
                    imagen_int_1: data.datos.imagen_int_1,
                    imagen_int_2: data.datos.imagen_int_2,
                    imagen_int_3: data.datos.imagen_int_3,
                };
                setGalleryImages(existingImages);
            }

            // Initialize billing data
            const datos_liquidacion = data.facturacion.length > 0 ? data.facturacion[0] : null;
            setBillingForm({
                dato_fiscal: datos_liquidacion?.dato_fiscal || '',
                cbu: datos_liquidacion?.cbu || '',
                entidad: datos_liquidacion?.entidad || '',
                email: datos_liquidacion?.email_facturacion || datos_liquidacion?.email || '',
                porcentaje: datos_liquidacion?.porcentaje || ''
            });

            setBillingFiles({
                comprobante_afip: datos_liquidacion?.comprobante_afip,
                comprobante_cbu: datos_liquidacion?.comprobante_cbu,
                comprobante_entidad: datos_liquidacion?.comprobante_entidad
            });

            // Cargar previsualizaciones de archivos existentes
            ['comprobante_afip', 'comprobante_cbu', 'comprobante_entidad'].forEach(field => {
                if (datos_liquidacion?.[field]) {
                    // Si el archivo viene codificado (ej: "liquidaciones/archivo.pdf")
                    const fileName = datos_liquidacion[field].split('/').pop();
                    // Descargar y crear vista previa en caché
                    fetchFilePreview(fileName, field);
                }
            });
        }
    }, [data]);


    const fetchFilePreview = async (fileName, field) => {
        try {
            const response = await apiPrivateAntesala.get(`/usuario-facturacion/archivo/${fileName}`, {
                responseType: 'blob'
            });

            if (response.status === 200) {
                // Crear Object URL para vista previa en caché
                const objectUrl = URL.createObjectURL(response.data);

                setFilePreview(prev => ({
                    ...prev,
                    [field]: {
                        url: objectUrl,
                        fileName: fileName,
                        isExisting: true,
                        type: response.data.type,
                        blob: response.data
                    }
                }));
            }
        } catch (error) {
            console.error(`Error al cargar archivo ${fileName}:`, error);
        }
    };

    const fetch = async (setData, params, url, signal) => {
        const response = await apiPrivateAntesala.get(url, { params, signal });
        if (response.status == 201 || response.status == 200) {
            setData(response.data);
        }
    };

    const onHandleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const formData = new FormData();
            formData.append('_method', 'PUT');

            Object.keys(form).forEach(key => {
                if (form[key] && form[key].trim() !== '') {
                    formData.append(key, form[key]);
                }
            });

            // Add gallery images
            Object.keys(galleryImages).map((key) => {
                formData.append(`${key}`, galleryImages[key]);
            })

            const response = await RestPrivateAntesala({
                url: `/auth/me`,
                formData: formData,
                method: "post",
                setLoading: setLoading,
            });

            if (response && response.status === 200) {
                console.log('Profile updated successfully');
            }
        } catch (error) {
            console.error('Error updating profile:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleInputChange = (name, value) => {
        setForm(prev => ({
            ...prev,
            [name]: value
        }));
    };


    const removeImage = (index) => {
        setGalleryImages(prev => {
            return {
                ...prev,
                [index]: null
            };
        });
    };

    const replaceImage = (index, file) => {
        setGalleryImages(prev => {
            return {
                ...prev,
                [index]: file
            };
        });
    };

    const handleBillingSubmit = async (e) => {
        e.preventDefault();
        setBillingLoading(true);

        try {
            const formData = new FormData();
            formData.append('id', data.facturacion[0].id);
            formData.append('_method', 'PUT');

            // Add billing form fields
            Object.keys(billingForm).forEach(key => {
                if (billingForm[key] && String(billingForm[key]).trim() !== '') {
                    formData.append(key, billingForm[key]);
                }
            });
            
            // Add billing files
            Object.keys(billingFiles).forEach(key => {
                if (billingFiles[key] && billingFiles[key] instanceof File) {
                    formData.append(key, billingFiles[key]);
                }
            });

            const response = await RestPrivateAntesala({
                url: `/usuario-facturacion/${data.facturacion[0].id}`,
                formData: formData,
                method: "post",
                setLoading: setBillingLoading,
            });

            if (response && response.status === 200) {
                console.log('Billing data updated successfully');
            }
        } catch (error) {
            console.error('Error updating billing data:', error);
        } finally {
            setBillingLoading(false);
        }
    };

    const handleBillingInputChange = (name, value) => {
        setBillingForm(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleBillingFileChange = (name, file) => {
        setBillingFiles(prev => ({
            ...prev,
            [name]: file
        }));

        // Generar previsualización para archivo nuevo
        if (file) {
            if (file.type.startsWith('image/')) {
                const reader = new FileReader();
                reader.onloadend = () => {
                    setFilePreview(prev => ({
                        ...prev,
                        [name]: reader.result
                    }));
                };
                reader.readAsDataURL(file);
            } else if (file.type === 'application/pdf') {
                setFilePreview(prev => ({
                    ...prev,
                    [name]: 'pdf'
                }));
            } else {
                setFilePreview(prev => ({
                    ...prev,
                    [name]: file.name
                }));
            }
        }
    };

    const downloadDocument = async (tipo) => {
        try {
            if (!data.facturacion[0]?.id) {
                console.error('No liquidation ID available');
                return;
            }

            const liquidacionId = data.facturacion[0].id;
            const response = await apiPrivateAntesala.get(
                `/liquidaciones/${liquidacionId}/comprobante/${tipo}`,
                { responseType: 'blob' }
            );

            if (response.status === 200) {
                const blob = new Blob([response.data]);
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = `comprobante_${tipo}_${liquidacionId}.pdf`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            }
        } catch (error) {
            console.error('Error downloading document:', error);
        }
    };

    useEffect(() => {
        if (!provincias) {
            fetch(setProvincias, {}, "/provincias");
        }
    }, []);

    // Cleanup de Object URLs al desmontar
    useEffect(() => {
        return () => {
            Object.values(filePreview).forEach(preview => {
                if (preview?.url && preview?.isExisting) {
                    URL.revokeObjectURL(preview.url);
                }
            });
        };
    }, [filePreview]);

    return (
        <Perfil
            submit={onHandleSubmit}
            user={data}
            datos={data.datos}
            rol={data.roles[0].nombre}
            provincias={provincias ?? []}
            form={form}
            handleInputChange={handleInputChange}
            loading={loading}
            galleryImages={galleryImages}
            removeImage={removeImage}
            replaceImage={replaceImage}
            billingForm={billingForm}
            billingFiles={billingFiles}
            filePreview={filePreview}
            billingLoading={billingLoading}
            handleBillingSubmit={handleBillingSubmit}
            handleBillingInputChange={handleBillingInputChange}
            handleBillingFileChange={handleBillingFileChange}
            downloadDocument={downloadDocument} />
    )
}

export default PerfilController